export const lafiaUser_profile_img_path = (state) => {
  return state.lafia_user.profile_image.includes("/") ? state.lafia_user.profile_image : "/upload/user/profile_image/" + state.lafia_user.profile_image
}

export const isKRW = (state) => state.lang === "ko"

// ==================== JWT 인증 Getters ====================

// 사용자 로그인 상태 확인 (lafia_user 기반)
export const isAuthenticated = (state) => state.lafia_user.is_logined

export const accessToken = (state) => state.accessToken

export const userType = (state) => state.lafia_user.userType || "user"

export const isAdmin = (state) => (state.lafia_user.userType || "user") === "admin"

export const isStaff = (state) => (state.lafia_user.userType || "user") === "staff"

// 사용자 프로필 이미지 경로 (lafia_user 기반)
export const jwtUserProfileImagePath = (state) => {
  if (!state.lafia_user.profile_image) return "/upload/user/profile_image/default.png"
  return state.lafia_user.profile_image.includes("/") ? state.lafia_user.profile_image : "/upload/user/profile_image/" + state.lafia_user.profile_image
}

// 사용자 이름 (없으면 userId 반환)
export const jwtUserDisplayName = (state) => {
  return state.lafia_user.name || state.lafia_user.user_id || ""
}
